import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import ShareLocationIcon from '@mui/icons-material/ShareLocation';
import LogoutIcon from '@mui/icons-material/Logout';
import type { ComponentProps } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { SideNav, type NavItem } from '@aeg-presents/components/SideNav';
import { LogoImage } from '../../App.styled';

type RouterLinkProps = Omit<ComponentProps<typeof Link>, 'to'> & { href: string };

type AppNavigationProps = {
  onLogout: () => void;
};

const navigationItems: NavItem[] = [
  { label: 'Tours', icon: <ShareLocationIcon />, href: '/tours' },
  {
    label: 'Booking Support',
    icon: <ContactSupportIcon />,
    href: '/booking-support',
  },
];

function RouterLink({ href, ...props }: RouterLinkProps) {
  return <Link to={href} {...props} />;
}

function Logo() {
  return <LogoImage src="/images/elvis-white.svg" alt="Elvis" />;
}

export function AppNavigation({ onLogout }: AppNavigationProps) {
  const { pathname } = useLocation();
  const navItems = navigationItems.map((item) => ({
    ...item,
    isActive: pathname === item.href || (item.href !== '/' && pathname.startsWith(`${item.href}/`)),
  }));

  return (
    <SideNav
      navItems={navItems}
      logo={<Logo />}
      LinkComponent={RouterLink}
      bottomActions={[
        {
          label: 'Logout',
          icon: <LogoutIcon />,
          onClick: onLogout,
        },
      ]}
    />
  );
}
